module.exports = __webpack_public_path__ + "static/media/accepted_message_backdrop.3ff332ab.svg";